import { Post } from './interfaces';

export const getPosts = async (): Promise<Post[]> => {
  return await (await fetch(`${process.env.REACT_APP_STRAPI_URL}posts`)).json();
};
